var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("form", [
    _c("div", { staticClass: "dashboard-block" }, [
      _c("h2", [_vm._v("Commission")]),
      _vm._v(" "),
      _c("div", { staticClass: "panel panel-grey" }, [
        _c("div", { staticClass: "panel-body" }, [
          _c("div", { staticClass: "row row-clear-md-4" }, [
            _c("div", { staticClass: "col-xs-12 col-md-4" }, [
              _c(
                "div",
                {
                  class: _vm.$hasErrorClass(
                    _vm.$v.stateCommissionRate,
                    "form-group"
                  ),
                },
                [
                  _c("label", { staticClass: "control-label" }, [
                    _vm._v(_vm._s(_vm.clientName) + " Commission"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "input-group" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.$v.stateCommissionRate.$model,
                          expression: "$v.stateCommissionRate.$model",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: { name: "commission_rate", type: "number" },
                      domProps: { value: _vm.$v.stateCommissionRate.$model },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.$v.stateCommissionRate,
                            "$model",
                            $event.target.value
                          )
                        },
                      },
                    }),
                    _vm._v(" "),
                    _vm._m(0),
                  ]),
                  _vm._v(" "),
                  _c("vuelidate-help", {
                    attrs: {
                      label: "Commission rate",
                      field: _vm.$v.stateCommissionRate,
                    },
                  }),
                ],
                1
              ),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "panel-footer" },
          [
            _c(
              "ladda-button",
              {
                staticClass: "btn btn-sm btn-primary",
                attrs: { type: "submit", click: _vm.handleSaveChangesCallback },
              },
              [_vm._v("\n          Save Changes\n        ")]
            ),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "input-group-addon" }, [
      _c("i", { staticClass: "fa fa-percent" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }